import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { IRoomsDAO } from '../../../../api/rooms.dao';

export class OperatorsUploadJob extends JobConfiguration {
    public readonly type = JobType.OperatorsUpload;
    public readonly name = 'Upload Operators';
    public readonly description = 'Operators Upload';

    public async execute(execParams) {
        return IoC.Container.get(IRoomsDAO).importOperators(execParams);
    }
}

export default {
    [JobType.OperatorsUpload]: OperatorsUploadJob
};
